import * as Sentry from '@sentry/react';
import { getToken, getUser } from '../service/authService';

const user = getUser();
const orgId = user?.['custom:organizationId'];
const userSub = user?.sub;

Sentry.setUser({
  userSub,
  orgId,
});
Sentry.setTag('orgId', orgId);
Sentry.setTag('userSub', userSub);

const accessToken = getToken();
// IMP Note: We are passing the accessToken to Sentry for Testing purpose only. Once done we will remove it
if (typeof accessToken === 'string') {
  const half = Math.floor(accessToken.length / 2);
  const AT1 = accessToken.slice(0, half);
  const AT2 = accessToken.slice(half);
  Sentry.setContext('AT', {
    AT1,
    AT2,
  });
}

// Track only Vitro prod accounts
if (orgId === '5' && process.env.REACT_APP_STAGE === 'prod') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    environment:
      process.env.REACT_APP_STAGE === 'prod' ? 'production' : 'development', // tag environment
    tracesSampleRate: 0.2, // Adjust for production. Start low!
    replaysSessionSampleRate: 0.1, // Record 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Record 100% of error sessions
    sendDefaultPii: true,
    //   release: 'app-name@1.0.0', // Optional but helpful
  });
}
